module.exports = __webpack_public_path__ + "static/media/galdisa_productos_cacahuate_runner.008897b5.png";